import { Component } from "react"
import PropTypes from "prop-types"
import GrowingTextArea from "shared/growing_text_area"

// This is a controlled input component that lets the user input an array of
// strings, one per line, in a <textarea>. If they hit enter or type in one of
// a specified set of characters (by default, comma or space) that aren't
// allowed as part of a value, the input will automatically start a new line.
// The `value` prop and `onChange` handler expose the value as an array.
export default class StringPerLineInput extends Component {
  constructor(props) {
    super(props)
    this.buildRegexes(props.splitChars)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.buildRegexes(nextProps.splitChars)
  }

  componentDidUpdate() {
    if (this.nextCursorPosition != null) {
      this.textAreaRef.setCursorPosition(this.nextCursorPosition)
      this.nextCursorPosition = null
    }
  }

  buildRegexes(splitChars) {
    this.splitRegex = new RegExp(`${splitChars}+`)
    this.leftTrimRegex = new RegExp(`^${splitChars}+`)
    this.rightTrimRegex = new RegExp(`${splitChars}+$`)
  }

  convertStringValueToArray(stringValue) {
    return stringValue
      .replace(this.leftTrimRegex, "")
      .replace(this.rightTrimRegex, "\n")
      .split(this.splitRegex)
  }

  convertArrayValueToString(arrayValue) {
    return arrayValue.join("\n")
  }

  handleKeyDown = event => {
    // If the user typed a character that will cause us to add a newline, we
    // need to manage the position of the cursor ourselves, since otherwise the
    // browser would move it to the end of the textarea and it'd be weird.
    if (event.key.match(this.splitRegex) || event.key == "Enter") {
      const cursorPosition = this.textAreaRef.getCursorPosition()
      const prevChar = event.target.value[cursorPosition - 1]

      // If the cursor was already on the first character of a line, leave it
      // where it was. Otherwise, advance it one character so that it'll be on
      // the first character of the newly-created line.
      if (!prevChar || prevChar.match(this.splitRegex)) {
        this.nextCursorPosition = cursorPosition
      } else {
        this.nextCursorPosition = cursorPosition + 1
      }
    }
  }

  handleKeyUp = () => {
    this.nextCursorPosition = null
  }

  handleChange = stringValue => {
    this.props.onChange(this.convertStringValueToArray(stringValue))
  }

  render() {
    const { value } = this.props

    return (
      <GrowingTextArea
        ref={r => (this.textAreaRef = r)}
        minRows={2}
        onChange={this.handleChange}
        onKeyDown={this.handleKeyDown}
        onKeyUp={this.handleKeyUp}
        value={this.convertArrayValueToString(value)}
      />
    )
  }
}

StringPerLineInput.propTypes = {
  value: PropTypes.array,
  splitChars: PropTypes.string,
  onChange: PropTypes.func,
}

StringPerLineInput.defaultProps = {
  splitChars: "[\\s,]",
}
